import { apiClient } from '../../api/client';

export interface OnlaynZapisUvedomlenie {
  id: number;
  klientka: string | null;
  filial: string | null;
  master: string | null;
  usluga: string | null;
  vremya: string | null;
  kogda: string | null;
}

export interface LentaOnlaynZapisey {
  kursor: number;
  opros_sek: number;
  zapisi: OnlaynZapisUvedomlenie[];
  server_vremya: string;
}

/** Только чтение: показ и закрытие карточки ничего не меняют в записи. */
export async function fetchOnlaynZapisi(posle: number | null): Promise<LentaOnlaynZapisey> {
  const { data } = await apiClient.get<LentaOnlaynZapisey>('/zapis/onlayn-uvedomleniya', {
    params: posle === null ? {} : { posle },
  });

  return data;
}
